export default __webpack_public_path__ + "static/media/modal-onclick.2c5cd1e3.svg";